import { styled as e } from "styled-components";
var t = e.div`
    position: relative;
    background:
        ${"url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.02'/%3E%3C/svg%3E\")"} repeat,
        ${({ theme: e }) => e.colors.background};
`;
//#endregion
export { t as AppBackdrop };
